"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUpdateServiceFloor = exports.useCreateServiceFloor = exports.useFetchServiceFloor = void 0;
const react_redux_1 = require("react-redux");
const react_router_1 = require("react-router");
const AuthGuard_1 = require("../../components/tsComponents/AuthGuard");
const serviceFloorAction_1 = require("./serviceFloorAction");
const useFetchServiceFloor = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_1.useNavigate)();
    const fetchServiceFloorLoading = (0, react_redux_1.useSelector)((state) => state["serviceFloor/fetch"].loading);
    const fetchServiceFloorError = (0, react_redux_1.useSelector)((state) => state["serviceFloor/fetch"].error);
    const fetchServiceFloorData = (0, react_redux_1.useSelector)((state) => state["serviceFloor/fetch"].data);
    const fetchAllServiceFloorData = (0, react_redux_1.useSelector)((state) => state["serviceFloor/fetchAll"].data);
    const fetchServiceFloor = (payload) => __awaiter(void 0, void 0, void 0, function* () {
        let userLoggedIn = yield (0, AuthGuard_1.isLoggedIn)();
        if (!userLoggedIn) {
            history("/auth/sign-in");
            return;
        }
        yield dispatch((0, serviceFloorAction_1.fetch)(payload));
    });
    const fetchAllServiceFloor = (payload) => __awaiter(void 0, void 0, void 0, function* () {
        let userLoggedIn = yield (0, AuthGuard_1.isLoggedIn)();
        if (!userLoggedIn) {
            history("/auth/sign-in");
            return;
        }
        yield dispatch((0, serviceFloorAction_1.fetchAll)(payload));
    });
    return {
        fetchServiceFloorLoading,
        fetchServiceFloorError,
        fetchServiceFloorData,
        fetchServiceFloor,
        fetchAllServiceFloorData,
        fetchAllServiceFloor
    };
};
exports.useFetchServiceFloor = useFetchServiceFloor;
const useCreateServiceFloor = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_1.useNavigate)();
    const createServiceFloorLoading = (0, react_redux_1.useSelector)((state) => state["serviceFloor/create"].loading);
    const createServiceFloorError = (0, react_redux_1.useSelector)((state) => state["serviceFloor/create"].error);
    const createServiceFloorData = (0, react_redux_1.useSelector)((state) => state["serviceFloor/create"].data);
    const createServiceFloor = (payload, onComplete) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            let userLoggedIn = yield (0, AuthGuard_1.isLoggedIn)();
            if (!userLoggedIn) {
                history("/auth/sign-in");
                return;
            }
            const res = yield dispatch((0, serviceFloorAction_1.create)(payload));
            if (res.meta.requestStatus === "fulfilled") {
                onComplete(true, false, res.payload);
            }
            else if (res.meta.requestStatus === "rejected") {
                throw new Error("Error in creating service floor data");
            }
        }
        catch (error) {
            onComplete(false, true, error.message);
        }
    });
    return {
        createServiceFloorLoading,
        createServiceFloorError,
        createServiceFloorData,
        createServiceFloor
    };
};
exports.useCreateServiceFloor = useCreateServiceFloor;
const useUpdateServiceFloor = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_1.useNavigate)();
    const updateServiceFloorLoading = (0, react_redux_1.useSelector)((state) => state["serviceFloor/update"].loading);
    const updateServiceFloorError = (0, react_redux_1.useSelector)((state) => state["serviceFloor/update"].error);
    const updateServiceFloorData = (0, react_redux_1.useSelector)((state) => state["serviceFloor/update"].data);
    const updateServiceFloor = (payload, onComplete) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            let userLoggedIn = yield (0, AuthGuard_1.isLoggedIn)();
            if (!userLoggedIn) {
                history("/auth/sign-in");
                return;
            }
            const res = yield dispatch((0, serviceFloorAction_1.update)(payload));
            if (res.meta.requestStatus === "fulfilled") {
                onComplete(true, false, res.payload);
            }
            else if (res.meta.requestStatus === "rejected") {
                throw new Error("Error in updating service floor data");
            }
        }
        catch (error) {
            onComplete(false, true, error.message);
        }
    });
    return {
        updateServiceFloorLoading,
        updateServiceFloorError,
        updateServiceFloorData,
        updateServiceFloor
    };
};
exports.useUpdateServiceFloor = useUpdateServiceFloor;
